// extracted by extract-css-chunks-webpack-plugin
module.exports = {"columns":"_1618rv","collapse":"r8B6Mb"};